import "phaser";
import App from "../main";

export default class Boot extends Phaser.Scene {

    private canLauncScene: boolean = false;

    constructor() {
        super('boot');
    }
    preload() {
        App.gamezopSDK.initializeSDK();

        this.load.image('gameZopLoadingBg', 'GameZop/loader-bg.png');
        this.load.image('gameZopSKDLoading', 'GameZop/loading-logo.png');
        this.load.image('gameZopSKDLoaded', 'GameZop/favicon.png');
        this.load.image('gameZopLoading', 'GameZop/loading.png');
        this.load.image('gameZopLoaded', 'GameZop/loaded.png');

        // this.load.on('progress', (value) => {
           
        // });

        this.load.on('complete', () => {
            console.log("Boot Complete");
            this.scene.launch('preload');

            this.canLauncScene = true;
        });
    }
}